'use client';

import { type HTMLAttributes, type ReactNode, useEffect, useRef } from 'react';
import styles from './modal-background.module.scss';

const ModalBackground = ({ children, mode, ...restProps }: IProps) => {
	const modalRef = useRef(null);

	useEffect(() => {
		const dialogEl = modalRef.current;
		dialogEl.showModal?.();

		return () => {
			dialogEl.close?.();
		};
	}, []);

	return (
		<dialog
			ref={modalRef}
			className={`${styles.background} ${mode ? styles[mode] : ''}`}
			{...restProps}
		>
			{children}
		</dialog>
	);
};

export interface IProps extends HTMLAttributes<HTMLDialogElement> {
	children: ReactNode;
	mode?: 'subtle' | 'transparent';
}

export default ModalBackground;
